__turbopack_context__.v({
  "idAddress": "profile-menu-module__DSGNtq__idAddress",
  "idName": "profile-menu-module__DSGNtq__idName",
  "idText": "profile-menu-module__DSGNtq__idText",
  "identity": "profile-menu-module__DSGNtq__identity",
  "trigger": "profile-menu-module__DSGNtq__trigger",
  "triggerName": "profile-menu-module__DSGNtq__triggerName",
  "worn": "profile-menu-module__DSGNtq__worn",
  "wornEnd": "profile-menu-module__DSGNtq__wornEnd",
  "wornError": "profile-menu-module__DSGNtq__wornError",
  "wornLine": "profile-menu-module__DSGNtq__wornLine",
  "wornText": "profile-menu-module__DSGNtq__wornText",
  "wrap": "profile-menu-module__DSGNtq__wrap",
});
